<script lang="ts" setup>
/**
 * ログインが必要なことを示す表示。
 */
</script>

<template>
	<p class="revico-community-talk-require-login">投稿にはログインが必要です。</p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	.revico-community-talk-require-login {
		margin: 12px 0 12px 0;
		font-size: 0.8em;
		text-align: center;
		white-space: pre-wrap;
	}
}
</style>
